export default __webpack_public_path__ + "static/media/A7.b793e77e.png";